import ReactLoading, { LoadingType } from "react-loading";
import { Button, ExtendedButtonProps } from "@mui/material";

export interface ButtonOutlinedProps extends Omit<ExtendedButtonProps, "variant"> {
	variant?: "outlined" | "approve" | "reject" | "complete";
	loading?: boolean;
	loadingType?: LoadingType;
	loadingWidth?: string | number;
	loadingHeight?: string | number;
}

export const ButtonOutlined = ({
	"data-useremunit": useRemUnit = "false",
	loading = false,
	loadingType = "balls",
	variant = "outlined",
	loadingWidth,
	loadingHeight,
	children,
	...props
}: ButtonOutlinedProps) => {
	return (
		<Button disableElevation variant={variant} data-useremunit={useRemUnit} {...props}>
			{loading ? (
				<ReactLoading
					type={loadingType}
					width={loadingWidth ? loadingWidth : useRemUnit === "true" ? "2.4rem" : "24px"}
					height={loadingHeight ? loadingHeight : useRemUnit === "true" ? "2.4rem" : "24px"}
					color="currentColor"
				/>
			) : (
				children
			)}
		</Button>
	);
};
